export default __webpack_public_path__ + "static/media/android.94f9f175.png";